import { Categoria } from '../../shared/entity/Categoria';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';
import { StackParamList } from '../../../App';
import produtoApi from '../../apis/produtoApi';
import colors from '../../colors';
import { SIDE_PADDING, TOP_PADDING } from '../../constants';
import { usePedido } from '../../redux/pedido/pedidoHooks';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import ItemCategoria from './ItemCategoria';
import { RouteProp } from '@react-navigation/native';
import ProdutoNoPedido from '../../shared/entity/ProdutoNoPedido';

type Props = {
  navigation: StackNavigationProp<StackParamList, 'ListaSegundoSaborPage'>;
  route: RouteProp<StackParamList, 'ListaSegundoSaborPage'>;
};

const ListaSegundoSaborPage: React.FC<Props> = (props) => {
  const { navigation, route } = props;
  const [pedido] = usePedido();
  const primeiroSabor = route.params.primeiroSabor as ProdutoNoPedido;

  const [categorias, setCategorias] = useState<Categoria[]>([]);

  const getProdutosSegundoSabor = async () => {
    try {
      console.log('primeiroSabor', primeiroSabor);
      const res = await produtoApi.getListaSegundoSabor(primeiroSabor.produtoId);
      console.log('getProdutosSegundoSabor', res);

      setCategorias(res);
    } catch (err) {
      setTimeout(() => {
        getProdutosSegundoSabor();
      }, 5000);
    }
  };

  const goToProduto = (id: number) => {
    // console.log('VOU PRO ADD', primeiroSabor);
    navigation.navigate('AdicionarProdutoPage', { id, primeiroSabor });
  };

  useEffect(() => {
    getProdutosSegundoSabor();
  }, []);

  return (
    <PageContainer scrollView={true} header={<Header titulo={'Segundo sabor'} goBack />}>
      <View style={styles.content}>
        {categorias.length === 0 && <ActivityIndicator size={50} color={colors.primary} />}
        {categorias.map((categoria) => (
          <ItemCategoria
            key={categoria.id}
            categoria={categoria}
            goToProduto={goToProduto}
            defaultOpen
          />
        ))}
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  content: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    paddingTop: TOP_PADDING,
    width: '100%',
    backgroundColor: '#fff',
    alignItems: 'center'
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  }
});

export default ListaSegundoSaborPage;
